import type { Project } from "@/api/types/Project";

// Fixed tile colours, all with white text at ≥ 4.5:1 contrast.
const TILE_COLORS = ["#0F766E", "#2B59C3", "#7C3AED", "#B4235A", "#9A5B00", "#1F6F43", "#475569", "#C2410C"];

function colorFor(key: string): string {
  let h = 0;
  for (const ch of key) h = (h * 31 + ch.charCodeAt(0)) >>> 0;
  return TILE_COLORS[h % TILE_COLORS.length]!;
}

/** Project logo, or a coloured tile with the project key when there is none. */
export function ProjectLogo({ project, size = 28 }: { project: Pick<Project, "key" | "logo_url">; size?: number }) {
  const radius = Math.round(size / 4);
  if (project.logo_url) {
    return (
      <img
        src={project.logo_url}
        alt=""
        width={size}
        height={size}
        style={{ width: size, height: size, borderRadius: radius }}
        className="shrink-0 border border-border bg-surface object-cover"
      />
    );
  }
  return (
    <span
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: colorFor(project.key),
        fontSize: Math.max(9, Math.round(size * (project.key.length > 3 ? 0.3 : 0.38))),
      }}
      className="inline-flex shrink-0 items-center justify-center font-bold text-white"
    >
      {project.key.slice(0, 4)}
    </span>
  );
}
